import objectFitImages from 'object-fit-images';
import $ from 'jquery';
import 'slick-carousel';
import 'parsleyjs';
import 'parsleyjs/dist/i18n/pl';
import './utils/parsleyAyncEmailValidator';
import * as FilePond from 'filepond';
import filePondLocalePl from 'filepond/locale/pl-pl';
import FilePondPluginFileEncode from 'filepond-plugin-file-encode';
import Pikaday from 'pikaday';
import dayjs from 'dayjs';
import pikadayi18n from './pikaday-i18n.json';
import domRouter from './modules/domRouter';
import rangeSlider from './modules/rangeSlider';
import newsletterForm from './modules/newsletterForm';
import addOfferForm from './modules/addOfferForm';
import authForm from './modules/authForm';
import mapWithMarkers from './modules/map-with-markers';
import SearchForm from '../vue/office-search-form.vue';
import SearchFormGoogle from '../vue/office-search-form-google.vue';
import GalleryButton from '../vue/gallery-button.vue';
import Gallery from '../vue/gallery.vue';
import Vote from '../vue/vote.vue';
import MapWithMarkers from '../vue/map-with-markers/map-with-markers.vue';
import VueComponent from './modules/vue-component';
import config from './modules/config';
import userSettingsForm from './modules/userSettingsForm';
import modal from './modules/modal';
import isMobile from './utils/isMobile';
import charactersCounter from './modules/charactersCounter';
import Api from './modules/api';
import scrollTo from './utils/scroll-to';
import DistrictForm from '../vue/district-form.vue';

const slickOptions = {
  infinite: true,
  dots: false,
  autoplay: true,
  arrows: true,
  speed: 750,
  slidesToShow: 5,
  responsive: [
    {
      breakpoint: 1280,
      settings: {
        slidesToShow: 4,
      },
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
      },
    },
  ],
};

const parsleyOptions = {
  errorClass: 'download-report-form__input--invalid',
  successClass: 'download-report-form__input--success',
  errorsWrapper: '<div class="download-report-form__validation-wrap download-report-form__validation-wrap--active"></div>',
  errorTemplate: '<p class="download-report-form__validation-message"></p>',
};

const initReferencesSlider = ($el, $dotsContainer) => {
  $el.slick({
    dots: true,
    autoplay: false,
    cssEase: 'linear',
    arrows: false,
    speed: 500,
    appendDots: $dotsContainer,
    zIndex: 1,
    mobileFirst: true,
    responsive: [
      {
        breakpoint: 320,
        settings: {
          swipeToSlide: true,
          fade: false,
        },
      },
      {
        breakpoint: 1280,
        settings: {
          swipeToSlide: false,
          fade: true,
        },
      },
    ],
  });
};

const initPartnersSlider = ($container) => {
  const $slider = $('.js--partners-slider', $container);
  const $arrowsContainer = $('.js--arrows', $container);

  $slider.slick({
    ...slickOptions,
    appendArrows: $arrowsContainer,
  });
};

const initGalleryButton = ($galleryWrappers, $buttonClass) => {
  $galleryWrappers.each((index, node) => {
    const id = parseInt($(node).data('id'), 10);
    const el = `.js--gallery-btn[data-id="${id}"]`;
    const resource = $(el).data('resource');
    const text = $(el).data('text');

    const gallery = VueComponent(el, GalleryButton, {
      id,
      resource,
      className: $buttonClass,
      text,
    });
    gallery.init();
  });
};

const initGallery = ($galleryWrappers) => {
  $galleryWrappers.each((index, node) => {
    const id = parseInt($(node).data('id'), 10);
    const el = `.js--gallery[data-id="${id}"]`;
    const resource = $(el).data('resource');
    const mode = $(el).data('mode');

    const gallery = VueComponent(el, Gallery, { id, resource, mode });
    gallery.init();
  });
};

domRouter
  .add('all', () => {
    // Run object-fit-images polyfill
    objectFitImages();
  })
  .add('pm-city-page', () => {
    const $$ = {
      partnersSliderContainer: $('.js--partners-slider-container'),
      referencesSlider: {
        el: $('#js--references-slider'),
        dotsContainer: $('#js--references-slider-dots'),
      },
    };

    initPartnersSlider($$.partnersSliderContainer);
    initReferencesSlider($$.referencesSlider.el, $$.referencesSlider.dotsContainer);
    newsletterForm('#js--newsletter-form');
  })
  .add('pm-find-office-google-search', () => {
    const $$ = {
      el: $('#js--references-slider'),
      dotsContainer: $('#js--references-slider-dots'),
      galleryWrappers: $('.js--gallery-btn'),
      galleryButtonClass: 'property-box__gallery-button',
    };

    initReferencesSlider($$.el, $$.dotsContainer);
    initGalleryButton($$.galleryWrappers, $$.galleryButtonClass);
  })
  .add('pm-find-office', () => {
    const $$ = {
      sliderContainer: $('.js--partners-slider-container'),
      arrowsContainer: $('.js--arrows'),
      searchForm: $('#js--search-form'),
    };

    initPartnersSlider($$.sliderContainer);
    newsletterForm('#js--newsletter-form');

    const searchForm = VueComponent('#js--search-form', SearchForm, {
      type: $$.searchForm.data('type'),
      submitUrl: config('ENDPOINTS.SUBMIT_SEARCH'),
      i18n: {
        workstationsLabel: $$.searchForm.data('i18n-workstations-label'),
        workstationsPlaceholder: $$.searchForm.data('i18n-workstations-placeholder'),
        cityLabel: $$.searchForm.data('i18n-city-label'),
        cityPlaceholder: $$.searchForm.data('i18n-city-placeholder'),
        cityNoResults: $$.searchForm.data('i18n-city-no-results'),
        search: $$.searchForm.data('i18n-search'),
      },
    });
    searchForm.init();
  })
  .add('pm-find-office-google-search', () => {
    const $$ = {
      sliders: $('.js--partners-slider-container'),
      arrowsContainer: $('#js--arrows'),
      searchForm: $('#js--search-form'),
    };

    $$.sliders.each((_, el) => {
      initPartnersSlider(el);
    });
    newsletterForm('#js--newsletter-form');

    const searchForm = VueComponent('#js--search-form', SearchFormGoogle, {
      type: $$.searchForm.data('type'),
      submitUrl: config('ENDPOINTS.SUBMIT_SEARCH'),
      i18n: {
        workstationsLabel: $$.searchForm.data('i18n-workstations-label'),
        workstationsPlaceholder: $$.searchForm.data('i18n-workstations-placeholder'),
        cityLabel: $$.searchForm.data('i18n-city-label'),
        cityPlaceholder: $$.searchForm.data('i18n-city-placeholder'),
        cityNoResults: $$.searchForm.data('i18n-city-no-results'),
        search: $$.searchForm.data('i18n-search'),
      },
    });
    searchForm.init();
  })
  .add('pm-city-map-page', async () => {
    newsletterForm('#js--newsletter-form');
    const selectors = {
      map: '#js--map',
      searchForm: '#js--form',
      properties: '.js--property',
    };

    const $$ = {
      map: $(selectors.map),
      searchForm: $(selectors.searchForm),
      properties: $(selectors.properties),
    };

    const api = Api();
    const {
      count, region, city, country, unavailable,
    } = $$.map.data();

    const markers = await api.getMarkers({
      count, region, city, country,
    });
    const propertyActiveClass = 'property-box--focus';

    const map = VueComponent(selectors.map, MapWithMarkers, {
      options: {},
      markers,
      unavailable,
    });

    const vm = map.init();

    vm.$on('marker-click', async ({ id }) => {
      const $property = $$.properties.filter((index, property) => $(property)
        .data('id') === id)
        .eq(0);

      await scrollTo($property);
      $property.addClass(propertyActiveClass);
      setTimeout(() => {
        $property.removeClass(propertyActiveClass);
      }, 1200);
    });

    const districtForm = VueComponent(selectors.searchForm, DistrictForm, {
      submitUrl: config('ENDPOINTS.SUBMIT_DISTRICT_SEARCH'),
      city: $$.searchForm.data('city'),
      count: $$.searchForm.data('count'),
      from: $$.searchForm.data('from'),
      to: $$.searchForm.data('to'),
      selectedDistricts: $$.searchForm.data('selected-districts'),
      i18n: {
        districtPlaceholder: $$.searchForm.data('i18n-district-placeholder'),
        districtNoResults: $$.searchForm.data('i18n-district-no-results'),
        count: $$.searchForm.data('i18n-count'),
        countPlaceholder: $$.searchForm.data('i18n-count-placeholder'),
        from: $$.searchForm.data('i18n-from'),
        fromPlaceholder: $$.searchForm.data('i18n-from-placeholder'),
        to: $$.searchForm.data('i18n-to'),
        toPlaceholder: $$.searchForm.data('i18n-to-placeholder'),
      },
    });
    districtForm.init();

    $('#js--report-form')
      .parsley(parsleyOptions);

    const $gParams = {
      galleryWrappers: $('.js--gallery-btn'),
      galleryButtonClass: 'property-box__gallery-button',
    };
    initGalleryButton($gParams.galleryWrappers, $gParams.galleryButtonClass);
  })
  .add('pm-city-page', async () => {
    const $$ = {
      slider: $('.js--slider'),
      galleryWrappers: $('.js--gallery'),
    };

    $$.slider
      .each((index, el) => {
        const $slider = $('.js--slider-container', el);
        const $handles = {
          min: $('.js--slider-min', el),
          max: $('.js--slider-max', el),
        };

        const sliderEl = $slider.get(0);
        const minEl = $handles.min.get(0);
        const maxEl = $handles.max.get(0);
        const options = {
          start: [$(el)
            .data('start'), $(el)
            .data('end')],
          range: {
            min: $(el)
              .data('min'),
            max: $(el)
              .data('max'),
          },
        };

        const slider = rangeSlider(sliderEl, minEl, maxEl, options);

        slider.on('update', (values, handleIndex) => {
          const handles = [
            'min',
            'max',
          ];
          const handle = handles[handleIndex];
          const value = parseInt(values[handleIndex], 10);
          $handles[handle].text(value);
        });
      });
    initGallery($$.galleryWrappers);
  })
  .add('pm-first-offer-page', () => {
    newsletterForm('#js--newsletter-form');
    mapWithMarkers({
      $map: $('#js--map'),
      $markers: $('.js--map-marker'),
      $properties: $('.js--property'),
    });
    $('#js--report-form')
      .parsley(parsleyOptions);
  })
  .add('pm-market-watch-page', () => {
    newsletterForm('#js--newsletter-form');
    mapWithMarkers({
      $map: $('#js--map'),
      $markers: $('.js--map-marker'),
      $properties: $('.js--property'),
    });
    $('#js--report-form')
      .parsley(parsleyOptions);
  })
  .add('pm-single-news-page', () => {
    newsletterForm('#js--newsletter-form');
  })
  .add('pm-news-archive-page', () => {
    newsletterForm('#js--newsletter-form');
  })
  .add('pm-our-team-page', () => {
    newsletterForm('#js--newsletter-form');
  })
  .add('pm-city-selection-page', () => {
    newsletterForm('#js--newsletter-form');
  })
  .add('pm-property-details-page', () => {
    const galleryElSelector = '#js--gallery';
    const $galleryEl = $(galleryElSelector);
    const { id, galleryId } = $galleryEl.data();
    const text = $galleryEl.data('text');

    const gallery = VueComponent(galleryElSelector, GalleryButton, {
      id,
      galleryId,
      className: 'property-report__button',
      text,
    });

    gallery.init();
  })
  .add('pm-city-properties-archive', () => {
    newsletterForm('#js--newsletter-form');
    mapWithMarkers({
      $map: $('#js--map'),
      $markers: $('.js--map-marker'),
      $properties: $('.js--property'),
    });
    $('#js--report-form')
      .parsley(parsleyOptions);
  })
  .add('pm-partners-page', () => {
    newsletterForm('#js--newsletter-form');
  })
  .add('pm-investments-archive-page', () => {
    newsletterForm('#js--newsletter-form');
  })
  .add('pm-contact', () => {
    newsletterForm('#js--newsletter-form');
    mapWithMarkers({
      $map: $('#js--map'),
      $markers: $('.js--map-marker'),
      $properties: $('.js--property'),
    }, {
      fitBounds: false,
    });

    $('#js--contact-form')
      .parsley({
        errorClass: 'contact-form__input--invalid',
        successClass: 'contact-form__input--success',
        errorsWrapper: '<div class="contact-form__validation-wrap contact-form__validation-wrap--active"></div>',
        errorTemplate: '<p class="contact-form__validation-message"></p>',
      });
  })
  .add('pm-registration-page', () => {
    authForm('#js--auth-form');
  })
  .add('pm-login-page', () => {
    authForm('#js--auth-form');
  })
  .add('pm-reset-password-page', () => {
    authForm('#js--auth-form');
  })
  .add('pm-add-property', () => {
    FilePond.registerPlugin(FilePondPluginFileEncode);
    FilePond.create(document.querySelector('#js--file-input'), {
      credits: false,
      allowMultiple: true,
      allowProcess: false,
      ...filePondLocalePl,
    });

    $('#js--add-property-form')
      .parsley({
        errorClass: 'add-property-form__input--invalid',
        successClass: 'add-property-form__input--success',
        errorsWrapper: '<div class="add-property-form__validation-wrap add-property-form__validation-wrap--active"></div>',
        errorTemplate: '<p class="add-property-form__validation-message"></p>',
      });
  })
  .add('pm-subscribed-offers-page', () => {
    newsletterForm('#js--newsletter-form');
    mapWithMarkers({
      $map: $('#js--map'),
      $markers: $('.js--map-marker'),
      $properties: $('.js--property'),
    });
    $('#js--report-form')
      .parsley(parsleyOptions);
  })
  .add('pm-compare-offers', () => {
    mapWithMarkers({
      $map: $('#js--summary-table-map'),
      $markers: $('.js--summary-table-map-marker'),
      $properties: $('.js--summary-table-property'),
    });
    addOfferForm('#js--add-offer-form');
    modal({
      openButtonSelector: '#js--open-modal',
      closeButtonSelector: '#js--close-modal',
      modalSelector: '#js--modal',
    }, {
      bodyActiveClass: 'is-modal-active',
      modalActiveClass: 'user-panel__popup-wrapper--active',
    });
  })
  .add('pm-offer-request-page', () => {
    authForm('#js--auth-form');

    FilePond.registerPlugin(FilePondPluginFileEncode);
    FilePond.create(document.querySelector('#js--file-input'), {
      credits: false,
      allowMultiple: true,
      allowProcess: false,
      ...filePondLocalePl,
    });

    const $dateInputs = $('.js--date-picker');

    const FORMAT = 'YYYY-MM-DD';
    $dateInputs.each((index, el) => {
      // Use native date picker on mobiles
      if (isMobile()) {
        $(el)
          .prop('type', 'date')
          .prop('readonly', false);
        return;
      }

      // eslint-disable-next-line
      new Pikaday({
        field: el,
        toString(date) {
          return dayjs(date)
            .format(FORMAT);
        },
        parse(dateString) {
          return dayjs(dateString, FORMAT)
            .toDate();
        },
        i18n: pikadayi18n,
        firstDay: 1,
      });
    });
  })
  .add('pm-user-account-settings-page', () => {
    userSettingsForm('#js--account-settings-form');
    charactersCounter({
      inputSelector: '.js--message-input',
      countContainerSelector: '#js--counter-container',
      counterSelector: '#js--counter',
      noCharactersLeftClass: 'user-settings-form__counter--limit-exceeded',
    });
  })
  .add('pm-property-comparison', () => {
    const $$ = {
      votes: $('.js--vote'),
      galleryWrappers: $('.js--gallery'),
    };

    $$.votes.each((index, el) => {
      const {
        upVotes, downVotes, itemId, featureId, upVoteText, downVoteText, label,
      } = $(el)
        .data();

      const vote = VueComponent(el, Vote, {
        label,
        upVoteText,
        downVoteText,
        upVotes,
        downVotes,
        itemId,
        featureId,
      });
      vote.init();
    });
    initGallery($$.galleryWrappers);
  })
  .add('pm-web-summary-page', () => {
    const $maps = $('.js--map');

    $maps.each((index, map) => {
      const $map = $(map);

      mapWithMarkers({
        $map,
        $markers: $('.js--map-marker', $map),
      }, {}, {
        shouldBindEvents: false,
      });
    });
  })
  .run();
